import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IUIState {
    challengeButtonBlink: boolean;
}

const initialState: IUIState = {
    challengeButtonBlink: false,
};

const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        setChallengeButtonBlinkState: (state, action: PayloadAction<boolean>) => {
            state.challengeButtonBlink = action.payload;
        },
    },
});

export default uiSlice.reducer;
export const { setChallengeButtonBlinkState } = uiSlice.actions;